import { useQuery } from '@tanstack/react-query';

import { adminApi } from '../api/admin.adapter';
import type { ListAdminsParams } from '../types/admin.types';

export const adminQueryKeys = {
  all: ['admins'] as const,
  // The list key embeds params so each filter/sort/page combo caches independently.
  list: (params: ListAdminsParams) => [...adminQueryKeys.all, 'list', params] as const,
  rootTransferCandidates: () =>
    [...adminQueryKeys.all, 'root-transfer-candidates'] as const,
};

export function useAdminsQuery(params: ListAdminsParams) {
  return useQuery({
    queryKey: adminQueryKeys.list(params),
    queryFn: () => adminApi.listAdmins(params),
  });
}

export function useRootTransferCandidatesQuery(enabled: boolean) {
  return useQuery({
    queryKey: adminQueryKeys.rootTransferCandidates(),
    queryFn: () => adminApi.listRootTransferCandidates(),
    enabled,
  });
}
